import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'dexTrancheTableTick'
})
export class DexTrancheTableTickPipe implements PipeTransform {

    public transform(tick: boolean | undefined) {
        return tick ? '✔' : tick === false ? '✗' : 'N/A';
    }

}
